<template>
  <NamedTabs
    :tabs="tabs"
    @change="onTabChange"
    @input="onTabInput"
  />
</template>
<script>
import NamedTabs from '@/views/theme2/components/namedTabs.vue'
import profileTabs from '@/views/logics/profile/profileTabs'

export default {
  name: 'ProfileTabs',
  components: {
    NamedTabs,
  },
  mixins: [profileTabs],
  computed: {
    tabs() {
      return this.filtredtabsItem.map(tab => ({
        title: tab.title,
        icon: tab.icon,
        isActive: this.$route.name === tab.link?.name,
        hidden: tab.hidden,
      }))
    },
  },
  methods: {
    onTabChange({ index }) {
      this.tabClick(this.filtredtabsItem[index])
    },
    onTabInput(index) {
      this.tabNumber = index
    },
  },
}
</script>
  <style lang="scss" scoped>
  ::v-deep.router-link-exact-active {
    color: white;
  }
  </style>
